import React, {
    useState,
    useEffect,
    useRef,
    useMemo,
    useCallback,
  } from "react";
  import { NavLink } from "react-router-dom";
  import ClipLoader from "react-spinners/ClipLoader";
  import axios from "../../axios";
  import { AgGridReact } from "ag-grid-react";
  import logo from "../../Assets/images/Swaasa.png";
  import { Grid, GridApi } from "ag-grid-community"; // the AG Grid React Component
  import "ag-grid-community/styles/ag-grid.css";
  // import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
  import "ag-grid-community/styles/ag-theme-material.css";
  import { act } from "react-dom/test-utils";
  // import HashLoader from "react-spinners/HashLoader";
  import exportIcon from '../../Assets/images/export.png';

  
  const DoctorsTable = (props) => {
    const [rowData, setRowData] = useState(props.rows);
    const getProfile = props.getProfilehandler;
  
    const [columnDefs] = useState([
      { headerName: "Doctor", field: "firstname" },
      { headerName: "Assessments", field: "assessmentCount" },
      { headerName: "Location", field: "locations" },
      { headerName: "Contact", field: "contact" },
      { headerName: "Email", field: "loginId" },
      { headerName: "Hospital", field: "hospitals" },
    ]);
    const [totalResults, tResults] = useState(0);
    // let totalResults;
    const defaultColDef = {
      // set every column width
      // width: 170,
      flex: 1,
      sortable: true,
      resizable:true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
    };
  
    const [gridApi, setGridApi] = useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
  
    // let gridApi;
    // const onGridReady = (params) => {
    //   gridApi = params.api;
    // };
    const exportData = () => {
      gridApi.exportDataAsCsv();
    };
    const [height, setWidth] = useState(window.innerHeight);
  
    //handling row count
    const [rowCount, setRowCount] = useState(0);
    function handleGridReady(params) {
      const count = params.api.getDisplayedRowCount();
      gridApiRef.current = params.api;
      setRowCount(count);
    }
  
    function handleFilterChanged(params) {
      const count = params.api.getDisplayedRowCount();
      setRowCount(count);
    }

    const [disabled, setdisabled] = useState(props.disabled);

    const [lastKey, setLastKey] = useState(props.lastKey);

    useEffect(() => {
      console.log("next", disabled);
    }, []);
    
    // const getDoctors = async (Key) => {
    //   try {
    //     const response = await axios.get(`/getDoctors?last_e_key=${lastKey}`, {
    //       headers: {
    //         accessToken: localStorage.accessToken,
    //       },
    //     });
  
    //     setRowData(response.data.data.users);
    //     setLastKey(response.data.last_key);
    //     if (response.data.last_key === "e30=") {
    //       setdisable(true);
    //     } else {
    //       setdisable(false);
    //     }

    //     setDataArray((prevArray) => [...prevArray, response.data.last_key]);
       
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    
    const [dataArray, setDataArray] = useState(["", props.lastKey]);
    console.log(dataArray)

    useEffect(() => {
      console.log("nextarray", dataArray);
    }, [dataArray]);

    const getDoctors = async (Key) => {
      try {
        const response = await axios.get(`/getDoctors?userId=${props.userProps}&last_e_key=${Key}&page_limit=50`, {
          headers: {
            accessToken: localStorage.accessToken,
          },
        });
        setRowData(response.data.data.users);
        setLastKey(response.data.last_key);
        if (response.data.last_key === "e30=") {
          setdisabled(true);
        } else {
          setdisabled(false);
        }
        setDataArray((prevArray) => [...prevArray, response.data.last_key]);
        
      } catch (error) {
        console.log(error);
      }
    };


    const getprevDoctors = async (Key) => {
      try {
        const response = await axios.get(`/getDoctors?userId=${props.userProps}&last_e_key=${Key}&page_limit=50`, {
          headers: {
            accessToken: localStorage.accessToken,
          },
        });
        setdisabled(false);
  
        setRowData(response.data.data.users);
        setLastKey(response.data.last_key);
        setDataArray((prevArray) => [...prevArray, response.data.last_key]);
       
        console.log(response.data);
  
      } catch (error) {
        console.log(error);
      }
    };

    const gridOptions = {
      overlayNoRowsTemplate: "No Doctors Found For This Organization",
    };




    const handlePrevPage = () => {
      const removedElement1 = dataArray.pop();
      const removedElement2 = dataArray.pop();
      console.log(dataArray);
  
      if (dataArray.length > 1) {
        getprevDoctors(dataArray[dataArray.length - 1]);
      } else {
        getprevDoctors("");
      }
    };
  
    const handleNextPage = () => {
      if (dataArray.length >= 1) {
        getDoctors(dataArray[dataArray.length - 1]);
      } 
      else {
        getDoctors("");
      }
    };



    const [selectedRowData, setSelectedRow] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [data, setData] = useState([]);
    const handleInputChange = (e) => {
      setInputValue(e.target.value);
    };
  
    const onRowClicked = (event) => {
      setSelectedRow(event.data);
      // getProfile(event.data.loginId);
      // setInputValue(event.data.hospitals)       
    };

    const gridApiRef = useRef(null);


  // const exportToCsv = () => {
  //   const params = {
  //     fileName: 'data.csv',
  //     processCellCallback: (params) => {
  //       if (params.column.getColDef().field === 'contact' || params.column.getColDef().field === 'createdOn' || params.column.getColDef().field === 'patientId' || params.column.getColDef().field === ["records.length"])  {
  //         return `'${params.value}'`;
  //       }
  //       else if (params.column.getColDef().field === 'contact' || params.column.getColDef().field === 'createdOn' || params.column.getColDef().field === 'patientId' || params.column.getColDef().field === ["records.length"]) {
  //         const valueWithoutQuotes = `"${params.value}"`.slice(1, -1);
  //         return valueWithoutQuotes;
  //       }
  //       // return params.value;
  //       else {
  //         return params.value;
  //       }
        
  //     },
  //   };
  //   if (gridApiRef.current) {
  //     gridApiRef.current.exportDataAsCsv(params);
  //   }
  // };
    
    const onCloseDialog = () => {
      setSelectedRow(null);
    };
    const dialog = selectedRowData ? (
      <>
        <div className="dialog-overlay"></div>
        <div className="dialog-box">
          <div className="dialog-header">
            <h2>{selectedRowData.firstname}</h2>
            <button className="close-button" onClick={onCloseDialog}>
              X
            </button>
          </div>
          <br></br>
          <div className="dialog-body">
            <h3>{selectedRowData.role}</h3>
            <p>Qualifications: {selectedRowData.qualifications}</p>
            <p>specializations: {selectedRowData.specializations}</p>
            <p>Contact: {selectedRowData.contact}</p>
            <p>loginId: {selectedRowData.loginId}</p>
            <p>Hospital: {selectedRowData.hospitals}</p>
            {/* <input type="text" value ={selectedRowData.hospitals} onChange={handleInputChange}></input> */}
            {/* <form>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
          />
          <button type="button" onClick={handleFormSubmit}>
            Submit
          </button>
        </form>
        <ul>
          {data.map(item => (
            <li key={item.id}>{item.value}</li>
          ))}
        </ul> */}
            <p>Location: {selectedRowData.locations}</p>
            <p>zipcode: {selectedRowData.zipcode}</p>
          </div>
        </div>
      </>
    ) : null;
    return (
      <div>
        <div className="ag-theme-material" style={{ height: height - 200 }}>
          <AgGridReact
            defaultColDef={defaultColDef}
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={false}
            onGridReady={handleGridReady}
            onFilterChanged={handleFilterChanged}
            onRowClicked={onRowClicked}
            gridOptions={gridOptions}
            // onGridReady={(params) => {
            //   gridApiRef.current = params.api;
            // }}
          ></AgGridReact>
        </div>
        {/* <div>
          <div>Row Count: {rowCount}</div>
        </div> */}
        {dialog}
        <div>
          <button className="nextButton" onClick={handlePrevPage} disabled={dataArray.length < 3}>
            Prev
          </button>
          <button className="nextButton" onClick={handleNextPage} disabled={disabled === true}>
            Next
          </button>
          {/* <img className="export_iconn" onClick={exportToCsv} src={exportIcon} alt="" /> */}
          <p className="export_iconn2">Export</p>
      </div>
      </div>
    );
  };
  
  export default DoctorsTable;
  